"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function validateUser(user, errorMetaData = {}) {
    if (!user || Object.keys(user).length === 0) {
        const errorObject = {
            code: 'USER_NOT_FOUND',
            message: 'user not found',
            errorMetaData
        };
        throw errorObject;
    }
    if (!user.userId) {
        const errorObject = {
            code: 'USERID_NOT_FOUND',
            message: 'userId not found',
            errorMetaData
        };
        throw errorObject;
    }
    if (!user.companyId) {
        const errorObject = {
            code: 'COMPANYID_NOT_FOUND',
            message: 'companyId not found',
            errorMetaData
        };
        throw errorObject;
    }
}
exports.validateUser = validateUser;
//# sourceMappingURL=validateUser.js.map